import { ExpandableSection } from "../ExpandableSection";
import { Table } from "../Table";
import numeral from "numeral";

const PageviewsSection = ({ items, classes }) =>
  items?.length > 0 && (
    <ExpandableSection title="Pageviews per Media Title" classes={classes}>
      <Table
        classes={classes}
        columns={tableColumns}
        items={items.toSorted(
          (a, b) => b.value.screenPageViews - a.value.screenPageViews,
        )}
        keyField="key"
      />
    </ExpandableSection>
  );

const mediaTitleNoLangLabels = {
  "20min": "20 Minuten",
  "24heures": "24 heures",
  annabelle: "Annabelle",
  bazonline: "Basler Zeitung",
  bernerzeitung: "Berner Zeitung",
  bilan: "Bilan",
  contentHub: "Content Hub",
  cp: "Commercial Publishing",
  derbund: "Der Bund",
  encore: "Encore",
  femina: "Femina",
  fuw: "Finanz und Wirtschaft",
  lb: "Der Landbote",
  lematin: "Le Matin",
  lifestyle: "20 Minuten Lifestyle",
  tagesanzeiger: "Tages Anzeiger",
  tagi: "Tages Anzeiger",
  tdg: "Tribune de Genève",
  tio: "Tio",
  zsz: "Zürichsee Zeitung",
  zul: "Zürcher Unterländer",
};

const tableColumns = [
  {
    xs: 6,
    sm: 6,
    md: 6,
    label: "Media Title",
    field: "key",
    render: (data) => mediaTitleNoLangLabels[data.key] || data.key,
  },
  {
    xs: 3,
    sm: 3,
    md: 3,
    label: "Pageviews",
    field: "screenPageViews",
    render: (data) => data.value?.screenPageViews || 0,
  },
  {
    xs: 3,
    sm: 3,
    md: 3,
    label: "Avg Time on Page",
    field: "averageSessionDuration",
    render: (data) =>
      `${data.value?.averageSessionDuration ? numeral(data.value.averageSessionDuration).format("0.0") : 0}s`,
  },
];

export default PageviewsSection;
